import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import httpInterceptor from '../common/APIConfig';


const initialState = {
    accounts: [],
    account_count: 0,
    loading: false,
    isloaded: false,
    error: false,
    errorMessage: null
}

export const getAllAWSAccounts = createAsyncThunk(
        'getAllAWSAccounts',
        async (_, {rejectWithValue}) => {
    
 
        try {
            const response = await httpInterceptor.get(`admin/aws/accounts`)
            if (response.status === 200) {
                return response.data
            }
        } catch (error){
                console.log(error)
                if (!error.response){
                    return rejectWithValue(error.message) 
                }
                return rejectWithValue(error.response.data)
            } 
    })

export const getAllAWSAccountsSlice = createSlice({
    name: 'getAllAWSAccounts',
    initialState,
    error: null,
    reducers: {
        resetGetAllAWSAccountsError: state => {
            state.error = false
            state.errorMessage = null
        }
    },
    extraReducers: builder => {
        builder.addCase(getAllAWSAccounts.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getAllAWSAccounts.fulfilled, (state, action) => {
            state.accloading = false
            state.accountsResponse = action.payload
            state.isloaded = true
            state.accerror = false
        })
        builder.addCase(getAllAWSAccounts.rejected, (state, action) => {
            state.accloading = false
            state.accerrorMessage = action.payload
            state.isloaded = true
            state.accerror = true
        })
    }
})

export const { resetgetAllAWSAccountsError } = getAllAWSAccountsSlice.actions

export default getAllAWSAccountsSlice.reducer